import { put, takeEvery } from 'redux-saga/effects'
import ApiError from '../modules/error'

import { USER_NOT_AUTHORIZED } from '../constants/user'

//Requests
export default function* () {
	yield takeEvery(action => action.error, checkAuth)
}

//Auth / error check
function* checkAuth(action={}) {
	const { error } = action

	if (typeof error != 'object' ||
		error instanceof ApiError == false){
		throw error
	}

	if (typeof error == 'object' &&
		error instanceof ApiError &&
		error.status==401){
		yield put({type: 'RESET'})
		yield put({type: USER_NOT_AUTHORIZED})
	}
}